<template>
    <div class="card dashboard-card h-100">
        <div class="card-body">
            <div class="d-flex justify-content-between align-items-start mb-3">
                <div>
                    <span class="eyebrow">Retail Job pipeline</span>
                    <h4 class="card-title">Snapshot</h4>
                </div>
                <span class="badge badge-light summary-badge">{{ counts.all }}</span>
            </div>

            <div class="summary-grid">
                <div>
                    <small class="metric-label">Total opportunities</small>
                    <div class="metric-value">{{ counts.all }}</div>
                </div>
                <div>
                    <small class="metric-label">Sold</small>
                    <div class="metric-value text-success">{{ counts.sold }}</div>
                </div>
                <div>
                    <small class="metric-label">Active pipeline</small>
                    <div class="metric-value text-info">{{ activePipeline }}</div>
                </div>
                <div>
                    <small class="metric-label">Conversion</small>
                    <div class="metric-value text-primary">{{ conversionRate }}%</div>
                </div>
            </div>

            <div class="mini-chart" v-if="chartData.length > 1">
                <GChart
                    :settings="{ packages: ['corechart'] }"
                    type="ColumnChart"
                    :data="chartData"
                    :options="chartOptions"
                    :resizeDebounce="500"
                ></GChart>
            </div>
        </div>
    </div>
</template>
<script>
import { GChart } from "vue-google-charts";

export default {
    name: "SummaryPipelineCard",
    components: {
        GChart,
    },
    props: {
        counts: {
            type: Object,
            required: true,
        },
    },
    computed: {
        activePipeline() {
            return this.counts.leads + this.counts.qualification + this.counts.appointment + this.counts.estimate + this.counts.closing;
        },
        conversionRate() {
            if (!this.counts.all) {
                return 0;
            }

            return Math.round((this.counts.sold / this.counts.all) * 100);
        },
        chartData() {
            return [
                ["Stage", "Count", { role: "style" }],
                ["Leads", this.counts.leads, "#b7c4d6"],
                ["Qual.", this.counts.qualification, "#7c8da6"],
                ["Appt.", this.counts.appointment, "#4f6d8c"],
                ["Est.", this.counts.estimate, "#f6b93b"],
                ["Closing", this.counts.closing, "#e67e22"],
                ["Sold", this.counts.sold, "#18a85a"],
            ];
        },
        chartOptions() {
            return {
                legend: { position: "none" },
                height: 180,
                backgroundColor: "transparent",
                chartArea: { left: 30, top: 10, width: "88%", height: 125 },
                hAxis: { textStyle: { color: "#4c5968", fontSize: 14 } },
                vAxis: { minValue: 0, textStyle: { color: "#4c5968", fontSize: 14 } },
                tooltip: { textStyle: { color: "#28323c", fontSize: 16 } },
            };
        },
    },
};
</script>
<style scoped>
.dashboard-card {
    border: 1px solid #dbe4ea;
    border-radius: 16px;
    box-shadow: 0 12px 30px rgba(31, 60, 90, 0.08);
    min-height: 450px;
    margin-bottom: 20px;
}

.dashboard-card .card-body {
    background-color: #ffffff;
}
.eyebrow {
    display: block;
    color: #6f7d8a;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.card-title {
    margin: 4px 0 0;
    color: #24313f;
    font-size: 24px;
    font-weight: 700;
}

.summary-badge {
    font-size: 16px;
    padding: 10px 14px;
    border-radius: 999px;
    color: #1e5f98;
    background: #eef7ff;
}

.summary-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
}

.metric-label {
    color: #788491;
    display: block;
    margin-bottom: 4px;
}

.metric-value {
    color: #24313f;
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
}

.mini-chart {
    margin-top: 18px;
}
</style>